
/**
 * 负责处理主题相关模块
 */

const STYLE_KEY = 'SHIQUTUDU';

import APP from "../../main"

export default {
    namespaced: true,
    state: () => {
        return {
            theme: 'default'
        }
    },
    mutations: {
        /**
         * 切换主题
        */
        setTheme(state) {
            if (state.theme === 'default') {
                sessionStorage.setItem(STYLE_KEY, 'dark')
                let root = document.querySelector(':root')
                root.style.setProperty('--color-theme', '#000')
                root.style.setProperty('--color-text', '#f2f4f8')
                localStorage.setItem("bgcol", '#000');
                return state.theme = 'dark'
            }
            if (state.theme === 'dark') {
                sessionStorage.setItem(STYLE_KEY, 'default')
                let root = document.querySelector(':root')
                root.style.setProperty('--color-theme', localStorage.getItem('themeClor') ? localStorage.getItem('themeClor') : '#f2f4f8')
                localStorage.setItem("bgcol", localStorage.getItem('themeClor') ? localStorage.getItem('themeClor') : '#f2f4f8');
                root.style.setProperty('--color-text', '#333')
                return state.theme = 'default'
            }
        },
        /**
         * 初始化上次的主题
        */
        initTheme(state) {
            const THEME = sessionStorage.getItem(STYLE_KEY)
            if (!THEME) {
                state.theme = 'default'
            } else {

                state.theme = THEME
            }
        },
        /**
         * 鼠标移入
        */
        hoverStyle(state, eve) {
            if (state.theme === 'default') {
                const defaultStyle = { ...eve.target.style }
                // eve.target.style.color = '#f00'
                eve.target.style.backgroundColor = '#f2f4f8'
                eve.target.onmouseleave = () => {
                    eve.target.style = defaultStyle;
                }
            }

            if (state.theme === 'dark') {
                const defaultStyle = { ...eve.target.style }
                eve.target.style.color = '#333'
                eve.target.style.backgroundColor = '#aaa'
                eve.target.onmouseleave = () => {
                    eve.target.style = defaultStyle;
                }
            }
        }

    },
    actions: {

    },
    getters: {
        /**
         * 获取当前主题
        */
        getTheme(state) {
            if (state.theme === 'default') {
                return '深色模式'
            }
            if (state.theme === 'dark') {
                return '普通模式'
            }
            return '暂无'
        },
        /**
         * 主题颜色
        */
        getThemeStyle(state) {
            if (state.theme === 'default') {//默认主题
                return 'background-color: #FFF;color:#333333;'
            }

            if (state.theme === 'dark') {//深色主题
                return 'background-color: #000;color:#CACACA;'
            }
        },
        getThemeStyleContainer(state) {
            const bool = state.theme === 'default' ? true : false;

            if (APP.$route.path === '/index/cards') {//卡片视图
                return bool ? 'color:#cccccc;background-color: #323232;' : 'color:#cccccc;background-color: #323232;'
            }
            return ''
        }
    }

}

